export const CREATE = 'CREATE'
export const FETCH_ALL = 'FETCH_ALL'
export const FETCH = 'FETCH'
export const UPDATE = 'UPDATE'
export const DELETE = 'DELETE'

export const AUTH = 'AUTH'
export const LOGOUT = 'LOGOUT'